import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useReviews(params, pageSize) {
  const [data, setData] = useState(null);
  const [items, setItems] = useState([]);
  const key = JSON.stringify(params);

  const fetchPage = useCallback((skip) => {
    return api.get("/reviews", { params: { ...JSON.parse(key), skip, limit: pageSize } }).then((r) => {
      setData(r.data);
      setItems((prev) => (skip ? [...prev, ...r.data.items] : r.data.items));
    }).catch(() => setData({ items: [], total: 0, matching: 0 }));
  }, [key, pageSize]);

  useEffect(() => { fetchPage(0); }, [fetchPage]);
  return { data, items, hasMore: !!data && data.matching > items.length, loadMore: () => fetchPage(items.length) };
}
